import React from 'react';
import {useNavigate} from 'react-router-dom';
import PageBase from "../../components/PageBase";
import ClosedWon from "./Widgets/ClosedWon";
import PipelineStatus from "./Widgets/PipelineStatus";
import Pilot from "./Widgets/Pilot";
import HotOpportunities from "./Widgets/HotOpportunities";
import TouchbaseChampions from "./Widgets/TouchbaseChampions";
import HeatmapByEngagement from "./Widgets/HeatmapByEngagement";
import * as ROUTES from '../../utils/routes';

import './Widgets/Widgets.scss';

const Sales = props => {
	const navigate = useNavigate();

	const showReport = (title, data, selectedObject) => {
		navigate(ROUTES.DASHBOARD_REPORT, { state: { title, data, selectedObject } });
	};

	return (
		<PageBase title="Sales">
			<div className="widgets-container" style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
				<ClosedWon showReport={widget => showReport('Closed Won Opportunities', widget.data.data, 'opportunities')} />
				<PipelineStatus showReport={widget => showReport('Pipeline Status', widget.data.data, 'opportunities')} />
				<HotOpportunities showReport={widget => showReport('Hot Opportunities', widget.data.data, 'opportunities')} />
				<Pilot showReport={widget => showReport('Pilot', widget.data.data, 'opportunities')} />
				<HeatmapByEngagement showReport={widget => showReport('Heatmap by Engagement Status', widget.data.data, 'heatmaps')} />
				<TouchbaseChampions showReport={widget => showReport('Touchbase Champions', widget.data.data, 'heatmaps')} />
			</div>
		</PageBase>
	);
};

export default Sales;
